import { render, staticRenderFns } from "./modalVerificado.vue?vue&type=template&id=b8a8c1ec&"
import script from "./modalVerificado.vue?vue&type=script&lang=js&"
export * from "./modalVerificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports